"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedSize = exports.DECOMPRESSING_IGNORE_DIR = exports.DECOMPRESSING_WORKSPACE_DIR = exports.DECOMPRESSING_CONCURRENCY_LEVEL = exports.HASHING_CONCURRENCY_LEVEL = exports.MAX_SUPPORTED_FILE_SIZE = exports.isWin = void 0;
const os = require("os");
const process_1 = require("process");
exports.isWin = process_1.platform === 'win32';
// Current implementation supports up to 2GB per file
exports.MAX_SUPPORTED_FILE_SIZE = 2 * 1024 * 1024 * 1024 - 1;
exports.HASHING_CONCURRENCY_LEVEL = os.cpus().length;
exports.DECOMPRESSING_CONCURRENCY_LEVEL = os.cpus().length * 8;
exports.DECOMPRESSING_WORKSPACE_DIR = 'workspace';
exports.DECOMPRESSING_IGNORE_DIR = 'ignore';
exports.isSupportedSize = (size) => 0 < size && size < exports.MAX_SUPPORTED_FILE_SIZE;
//# sourceMappingURL=common.js.map